"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mean_1 = __importDefault(require("./dataProcessing/mean"));
var stdev_1 = __importDefault(require("./dataProcessing/stdev"));
var SparklinesNormalBand = function (props) {
    var _a = props.points, points = _a === void 0 ? [] : _a, _b = props.margin, margin = _b === void 0 ? 0 : _b, _c = props.style, style = _c === void 0 ? { fill: "red", fillOpacity: 0.1 } : _c;
    var ypoints = points.map(function (p) { return p.y; });
    var dataMean = mean_1.default(ypoints);
    var dataStdev = stdev_1.default(ypoints);
    return (react_1.default.createElement("rect", { x: points[0].x, y: dataMean - dataStdev + margin, width: points[points.length - 1].x - points[0].x, height: 2 * +stdev_1.default, style: style }));
};
exports.default = SparklinesNormalBand;
//# sourceMappingURL=SparklinesNormalBand.js.map